import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePermissions, useSession } from 'src/apps/invest/common/hooks';
import { CashFlowOfferingPage } from '../views/CashFlowOfferingPage';

const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const CashFlowOfferingController: React.FC = () => {
  const location = useLocation();
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();
  const sessionRedirect = location.pathname + location.search;

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  return <CashFlowOfferingPage />;
};
